<template>
  <v-radio-group
    @change="$emit('onChange', $event)"
    :value="selected"
    hide-details
    row>
    <v-radio
      v-for="(grade, index) in grades"
      :key="index"
      :label="grade.name"
      :value="grade.id"
      :disabled="!isValidGrade(grade.id) && disabled"
      color="secondary"
    ></v-radio>
  </v-radio-group>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    disabled: {
      type: Boolean,
      default: true,
    },
    selected: {
      type: Number,
      required: true,
    }
  },

  computed: {
    ...mapGetters([
      'isValidGrade',
    ]),
    grades() {
      return this.$store.state.master.allGrades
    },
  },
}
</script>
